import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import UserDropdown from "@/components/UserDropdown";
import logoAsk4gems from "@/assets/logo-ask4gems.svg";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  const navLinks = [
    { to: "/post-request", label: "Post a Buying Request", requiresAuth: true },
    { to: "/listings", label: "Browse Buying Requests", requiresAuth: true },
  ];

  const handleNavClick = (e: React.MouseEvent, link: { to: string; requiresAuth: boolean }) => {
    if (link.requiresAuth && !user) {
      e.preventDefault();
      navigate("/auth");
    }
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/60">
      <div className="container flex h-16 items-center justify-between">
        <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="flex items-center">
          <img src={logoAsk4gems} alt="Ask4gems logo - Professional gemstone marketplace" width={88} height={28} className="h-[28px]" />
        </Link>

        <nav className="hidden md:flex items-center gap-6">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={(e) => handleNavClick(e, link)}
              className={`text-sm font-medium transition-smooth hover:text-primary ${
                location.pathname === link.to
                  ? "text-primary"
                  : "text-muted-foreground"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          {loading ? (
            <div className="w-8 h-8 rounded-full bg-muted animate-pulse" />
          ) : user ? (
            <UserDropdown />
          ) : (
            <Link to="/auth">
              <Button variant="default" size="sm">
                Login
              </Button>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
